export default {
  getSubscriptionInfo: state => state.subscriptionInfo,
  getUnsubscribeInfo: state => state.unsubscribeInfo,
  getCreateSubscription: state => state.createSubscription,
  getErrors: state => {
    return state.errors;
  }
};
